var AttributeIconService = (function () {
    function AttributeIconService($http) {
        this.$http = $http;
    }
    AttributeIconService.prototype.getCommon = function () {
        return this.get().then(function (response) { return response.common; });
    };
    AttributeIconService.prototype.getTargetGroup = function () {
        return this.get().then(function (response) { return response.targetGroup; });
    };
    AttributeIconService.prototype.getWorksWith = function () {
        return this.get().then(function (response) { return response.worksWith; });
    };
    AttributeIconService.prototype.get = function () {
        return this.$http
            .get('compatibilityguide/ng-settings/feature/search/attributeicons')
            .then(function (response) {
            return response.data;
        });
    };
    AttributeIconService.$inject = ['$http'];
    return AttributeIconService;
}());
export { AttributeIconService };
